import { authApi } from './index';

export const getQuestionAnswers = async ({ faceUserId, category }) => {
	const params = { category };
	if (faceUserId) params.face_user_id = faceUserId;

	const { data } = await authApi.get('/portal/users/question-answers', {
		params,
	});

	return data;
};

export const updateQuestionAnswers = async ({ faceUserId, answers }) => {
	const { data } = await authApi.put(
		`/portal/users/${faceUserId}/question-answers`,
		{ answers },
	);

	return data;
};
